import { formatTonnes } from '../formatTonnes/formatTonnes';

type NumberFormattingOptions = {
  style?: 'decimal' | 'percent' | 'kilogram' | 'ton';
  minimumFractionDigits?: number;
  maximumFractionDigits?: number;
};

export const formatNumber = (value: number | string, options?: NumberFormattingOptions) => {
  const { style = 'decimal', minimumFractionDigits = 1, maximumFractionDigits } = options || {};

  const numericValue = Number(value);

  if (style === 'percent') {
    return (numericValue / 100).toLocaleString(undefined, {
      maximumFractionDigits,
      minimumFractionDigits,
      style,
    });
  }

  if (style === 'kilogram') {
    return numericValue.toLocaleString(undefined, {
      maximumFractionDigits,
      minimumFractionDigits,
      style: 'unit',
      unit: 'kilogram',
      unitDisplay: 'narrow',
    });
  }

  if (style === 'ton') {
    return formatTonnes(numericValue, options?.maximumFractionDigits);
  }

  return numericValue.toLocaleString(undefined, {
    maximumFractionDigits,
    minimumFractionDigits,
    style,
  });
};
